import { ActionReducerMap, MetaReducer } from '@ngrx/store';

import { State } from '../state';

import { authReducer } from './auth.reducer';

export const reducers: ActionReducerMap<State> = {
    auth: authReducer,
};
